import React from 'react';
import './about.css';
import Gallery from '../3d-gallery/Gallery';

const About = () => {
  return (
    <section id='about'>
      <div className='container title__container title__about'>
        <h5>Get to know</h5>
        <h2>About Me</h2>
      </div>
      <div className='container about__container'>
        <div className='about-text'>
          <article>
            Hey there! I'm Dmitry, a soon-to-be graduate at Haaga-Helia
            University, specializing in Data Processing. My journey into coding
            began in middle school, and my passion for programming has only
            grown stronger over time. With three years of active coding
            experience, I've developed expertise in React, TypeScript, Redux
            Toolkit, and Tailwind. I'm also keen on expanding my knowledge in
            technologies like Spring Boot, Docker, and AWS.
          </article>
          <article>
            My strengths lie in my excellent math skills and my ability to solve
            complex logical problems. I thrive on finding comprehensive
            solutions to challenging tasks, and programming isn't just a
            responsibility for me—it's a hobby that I genuinely enjoy.
          </article>
          <article>
            As I pursue opportunities as a Full Stack developer, I'm excited to
            apply my skills and explore new technologies. I'm motivated to join
            innovative teams and contribute to the development of impactful
            software solutions
          </article>
        </div>
        <div className='about-gallery'>
          <Gallery />
        </div>
      </div>
    </section>
  );
};

export default About;
